const PLACEHOLDER_PATTERN = /\{(\w+)\}/g;

/**
 * Substitutes `{name}` placeholders in a copy string. An unknown placeholder is
 * left in place rather than rendered as `undefined`.
 *
 * @param template - Copy string carrying `{name}` placeholders.
 * @param values - Values to substitute, keyed by placeholder name.
 * @returns The interpolated string.
 */
export function interpolate(template: string, values: Record<string, string | number>): string {
  return template.replace(PLACEHOLDER_PATTERN, (match, key: string) => (key in values ? String(values[key]) : match));
}
